import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import clsx from "clsx";

import styles from "./SidebarIcon.module.css";

type SidebarIconProps = {
  icon: IconDefinition;
  className?: string;
  muted?: boolean;
  size?: "md" | "sm";
};

function SidebarIcon({
  icon,
  className,
  muted = false,
  size = "md",
}: SidebarIconProps): React.JSX.Element {
  return (
    <FontAwesomeIcon
      icon={icon}
      className={clsx(
        styles.icon,
        size === "sm" && styles.iconSm,
        muted && styles.iconMuted,
        className,
      )}
      aria-hidden
    />
  );
}

export default SidebarIcon;
